module.exports = __webpack_public_path__ + "static/media/esquina_sur_abajo_1.c3ca756e.jpg";